import { render, staticRenderFns } from "./GenericTaskView.vue?vue&type=template&id=2a7b6d17&scoped=true&"
import script from "./GenericTaskView.vue?vue&type=script&lang=js&"
export * from "./GenericTaskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b6d17",
  null
  
)

export default component.exports